import { Component, OnInit } from '@angular/core';
import { HeaderEditorStoreService } from '../../header-editor-store.service';
import { HeaderConfig } from '@urbannex/storethemes';

@Component({
  selector: 'ngx-header-layout',
  templateUrl: './header-layout.component.html',
  styleUrls: ['./header-layout.component.scss']
})
export class HeaderLayoutComponent implements OnInit {
  title:string = "Header Layout";
  toolTip:string = "The tooltip";

  darkMode:boolean;

  kaka:HeaderConfig;

  topHeader:boolean;
  mainHeader:boolean;
  bottomHeader:boolean;

  options = [
    { value: 'This is value 1', label: 'Top Header' },
    { value: 'This is value 2', label: 'Main Header' },
    { value: 'This is value 3', label: 'Bottom Header' },
  ];

  fields = [
    {
      name:"background",
      title:"Background",
      type:"background",
      controlType:'color-picker'
    },
    {
      name:'padding',
      title:'Padding',
      type:'padding',
      controlType:'multiMeasure'
    },
    {
      name:"logo",
      title:"Logo URL",
      type:"string",
      controlType:""
    },
    {
      name:"siteName",
      title:"Site Name",
      type:"string",
      controlType:"text"
    },
  ]
  constructor(private headerEditorStore:HeaderEditorStoreService) { }

  ngOnInit(): void {
    
  }

  onChangeBottomRow(e){
    this.headerEditorStore.toggleHeaderRow("bottomHeader")   
  }

  onChangeTopRow($event){
    this.headerEditorStore.toggleHeaderRow("topHeader")  
  }

  onFieldUpdate(e){
    
    switch (e.name) {
      case "background":
        
        break;
      case "padding":
        
        break;
      case "logo":
        
        break;
      case "siteName":
        this.headerEditorStore.updateSiteName(e.value);
        break;
 
      default:
        break;
    }
  }

}
